import * as React from 'react';
import styles from './index.less';
import fMessage from '@/components/fMessage';
import { UpdateBaseInfoAction } from '@/models/exhibitInfoPage';
import FCoverImage from '@/components/FCoverImage';
import FIcons from '@/components/FIcons';
import { FI18n } from '@freelog/tools-lib';
import FUploadCover, {
  DEFAULT_ACCEPT_IMAGE_TYPES,
  type FUploadCoverImageType,
} from '@/components/FUploadCover';

type FCoverImageEditorImageType = FUploadCoverImageType;

interface FCoverImageEditorProps {
  src: string;
  width: number;
  use?: 'resource' | 'exhibit';
  lodding?: boolean;
  uploadDescription?: string;
  acceptImageTypes?: FCoverImageEditorImageType[];
  /** 禁用上传/编辑（仍展示封面） */
  disabled?: boolean;

  onChange?(url: string): void;
}

// function FCoverImageEditor({ src, use = 'exhibit', width, onChange }: FCoverImageEditorProps) {
//   return (<FUploadCover
//     style={{ height: 195 }}
//     use={use}
//     onError={(err) => {
//       fMessage(err, 'error');
//     }}
//     onUploadSuccess={(url: string) => {
//       onChange?.(url);
//     }}>
//     <div className={styles.cover}>
//       <FCoverImage
//         src={src}
//         width={width}
//         style={{ borderRadius: 6 }}
//       />
//       <div className={styles.coverEdit}>
//         <FIcons.FEdit style={{ fontSize: 32 }} />
//         <div style={{ height: 10 }} />
//         <div>{FI18n.i18nNext.tAuto('btn_edit_cover')}</div>
//       </div>
//     </div>
//   </FUploadCover>);
// }

function FCoverImageEditor({
  src,
  use = 'exhibit',
  width,
  lodding,
  uploadDescription,
  acceptImageTypes,
  disabled = false,
  onChange,
}: FCoverImageEditorProps) {
  const effectiveAcceptImageTypes = acceptImageTypes ?? DEFAULT_ACCEPT_IMAGE_TYPES;

  return (
    <FUploadCover
      key={effectiveAcceptImageTypes.join(',')}
      style={{ width: width, aspectRatio: 4 / 3 }}
      use={use}
      uploadDescription={uploadDescription}
      acceptImageTypes={effectiveAcceptImageTypes}
      disabled={disabled}
      onError={(err) => {
        fMessage(err, 'error');
      }}
      onUploadSuccess={(url: string) => {
        onChange?.(url);
      }}
    >
      <div
        className={styles.FCoverImageEditor}
        style={{ backgroundColor: '#f7f7f7', width: width, aspectRatio: 4 / 3 }}
      >
        {!src && (
          <>
            {lodding && (
              <div
                className={styles.hover_hidden}
                style={{
                  // width: 200,
                  // height: 150,
                  width: '100%',
                  height: '100%',
                  background: 'rgba(0,0,0,0.05)',
                  borderRadius: 4,
                  // opacity: 0.05,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  gap: 10,
                }}
              >
                <FIcons.FLoading style={{ fontSize: 16, color: '#999' }} />
                <div
                  style={{
                    fontWeight: 400,
                    fontSize: 14,
                    color: '#999',
                    lineHeight: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 10,
                  }}
                >
                  封面解析中
                </div>
              </div>
            )}

            {!lodding && (
              <>
                <FCoverImage src={''} width={width} />
                {/* <a className={styles.FUploadImageChildren}>
                  <FIcons.FCloudUpload />
                  <span>{FI18n.i18nNext.tAuto('upload_image')}</span>
                </a> */}
              </>
            )}
          </>
        )}

        {/* {src ? (
          <FCoverImage src={src || ''} width={width} />
        ) : (
          <a className={styles.FUploadImageChildren}>
            <FIcons.FCloudUpload />
            <span>{FI18n.i18nNext.tAuto('upload_image')}</span>
          </a>
        )} */}

        {src && (
          <>
            <FCoverImage src={src} width={width} />

            {lodding && (
              <div
                className={styles.hover_hidden}
                style={{
                  width: '100%',
                  height: '100%',
                  background: 'rgba(0,0,0,0.2)',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  gap: 10,
                }}
              >
                <FIcons.FLoading style={{ fontSize: 16, color: '#FFFFFF' }} />
                <div
                  style={{
                    fontWeight: 400,
                    fontSize: 14,
                    color: '#FFFFFF',
                    lineHeight: '20px',
                  }}
                >
                  封面解析中
                </div>
              </div>
            )}
          </>
        )}

        {!disabled && (
          <div className={[styles.hover_visible, styles.coverEdit].join(' ')}>
            <FIcons.FEdit style={{ fontSize: 32 }} />
            <div style={{ height: 10 }} />
            <div>{FI18n.i18nNext.tAuto('btn_edit_cover')}</div>
          </div>
        )}
      </div>
    </FUploadCover>
  );
}

export default FCoverImageEditor;
